import { Component, OnInit } from '@angular/core';
import { AgentDto } from '../../../../service/dto';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpAgentAdminService } from '../../../../service/http-agent.service';
import { HttpInsuranceBenefitApprovalPaymentService } from '../../../../service/http-insurance-benefit-payment-approval.service';
import { BenefitPaymentApprovalSettingDto } from '../../../../service/dto-insurance';

export interface ApprovalLevelDto {
	id?: number;
	level: number;
	paymentThreshold: number;
	agentIds: number[];
}


@Component({
	selector: 'app-benefit-payment-approval-setting',
	standalone: false,
	templateUrl: './benefit-payment-approval-setting.component.html',
	styleUrl: './benefit-payment-approval-setting.component.scss'
})
export class BenefitPaymentApprovalSettingComponent implements OnInit {
	agents: AgentDto[] = [];
	form?: FormGroup;
	constructor(private fb: FormBuilder, private httpService: HttpInsuranceBenefitApprovalPaymentService) { }

	ngOnInit(): void {
		this.form = this.fb.group({
			levels: this.fb.array([])
		});

		this.httpService.getSettings().subscribe(result => {
			this.init(result);
		});
		this.addLevel();
	}
	init(input: BenefitPaymentApprovalSettingDto[]) {
		if (input.length == 0) {
			this.httpService.getSettingAgents().subscribe(agents => this.agents = agents);
			this.form = this.fb.group({
				levels: this.fb.array([])
			});
			return;
		}
		this.agents = [...new Map(input.flatMap(item => item.agents).map(a => [a.agentId, a])).values()].map(item => {
			return { id: item.agentId, username: item.agentName, hashCode: item.agentId } as any as AgentDto;
		})
		let level = 0;
		this.form = this.fb.group({
			levels: this.fb.array(
				input.map(item => {
					return this.fb.group({
						id: [item.id],
						level: [++level],
						paymentThreshold: [item.paymentThreshold, [Validators.required]],
						allowedAgentIds: [item.agents.filter(i => i.allowedToApprove == true).map(i => i.agentId)]
					})
				})
			)
		});
	}

	// ---------- Form Helpers ----------
	get levels(): FormArray {
		return this.form!.get('levels') as FormArray;
	}

	addLevel(): void {
		this.levels.push(this.fb.group({
			level: [this.levels.length + 1],
			paymentThreshold: [0, Validators.required],
			allowedAgentIds: [[]]
		}));
	}

	removeLevel(index: number): void {
		this.levels.removeAt(index);
		this.resequence();
	}

	resequence(): void {
		this.levels.controls.forEach((ctrl, i) => {
			ctrl.get('level')?.setValue(i + 1);
		});
	}

	// ---------- Validation ----------
	get sortedLevels() {
		return [...this.levels.value].sort((a, b) => a.paymentThreshold - b.paymentThreshold);
	}

	hasDuplicateThresholds(): boolean {
		const values = this.levels.value.map((l: any) => l.paymentThreshold);
		return new Set(values).size !== values.length;
	}

	// ---------- Save ----------
	save(): void {
		if (this.form!.invalid || this.hasDuplicateThresholds()) {
			this.form!.markAllAsTouched();
			return;
		}

		const payload = this.sortedLevels;
		this.httpService.modifySettings(payload).subscribe();
		console.log('Saving approval levels', payload);
	}
}
